import { MapContainer, TileLayer, Marker, Popup, LayersControl, ScaleControl } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen.js';
import L from 'leaflet';
import { Link } from 'react-router-dom';
import { coordenadas } from '../../store/actions/coordenadas'
import { ultimoMeteorologico } from '../../store/actions/ultimoMeteorologico'
import { ultimoDulce } from '../../store/actions/ultimoDulce'
import { ultimoEntorno } from '../../store/actions/ultimoEntorno'
import { ultimoRiego } from '../../store/actions/ultimoRiego'
import { ultimoSalada } from '../../store/actions/ultimoSalada'
import { ultimoSuelo } from '../../store/actions/ultimoSuelo'
import { ultimoTesla } from '../../store/actions/ultimoTesla'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react';
import React, { useState } from 'react';
import '../home/map.css'
import '../home/styles.css'
import '../home/datosSensor.css'

const styles = {
    container: {
        fontFamily: "'Arial', sans-serif",
        padding: '20px',
        backgroundColor: '#f9f9f9',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: '600px',
        margin: 'auto',
    },
    header: {
        textAlign: 'center',
        color: '#333',
        marginBottom: '20px',
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '15px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 0',
        borderBottom: '1px solid #eee',
    },
    label: {
        fontWeight: 'bold',
        color: '#555',
    },
    value: {
        color: '#333',
    },
};

const { BaseLayer } = LayersControl;
const CustomPopup = ({ marker }) => {
    console.log(marker)
    const { item1, item2 } = marker;

    switch (item2) {
        case 'meteorologico':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Weather Information:</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Temperature:</span>
                            <span style={styles.value}>{item1.temperatura} °C</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Humidity:</span>
                            <span style={styles.value}>{item1.humedad} %</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Presure:</span>
                            <span style={styles.value}>{item1.presion} hPa</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Quality:</span>
                            <span style={styles.value}>{item1.calidad}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Wind Direction:</span>
                            <span style={styles.value}>{item1.direccion}°</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Wind Speed:</span>
                            <span style={styles.value}>{item1.velocidad} km/h</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Light Intensity:</span>
                            <span style={styles.value}>{item1.intensidad} lux</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Photoperiod:</span>
                            <span style={styles.value}>{item1.fotoperiodo} horas</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Precipitation:</span>
                            <span style={styles.value}>{item1.precipitaciones} mm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        case 'dulce':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Freshwater Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Temperature:</span>
                            <span style={styles.value}>{item1.temperatura} °C</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Turbidity:</span>
                            <span style={styles.value}>{item1.turbidez} NTU</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Conductivity:</span>
                            <span style={styles.value}>{item1.conductividad} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Light intensity:</span>
                            <span style={styles.value}>{item1.intensidad} mg/L</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Surf:</span>
                            <span style={styles.value}>{item1.oleaje}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        case 'tesla':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Tesla Node Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Active:</span>
                            <span style={styles.value}>{item1.activo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Corrent:</span>
                            <span style={styles.value}>{item1.corriente} A</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Voltage:</span>
                            <span style={styles.value}>{item1.tension} V</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Power:</span>
                            <span style={styles.value}>{item1.potencia} W</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        case 'entorno':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Environment Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Propano / GLP:</span>
                            <span style={styles.value}>{item1.CO} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Alcohol / Etanol:</span>
                            <span style={styles.value}>{item1.CO2} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Metano (CH₄):</span>
                            <span style={styles.value}>{item1.O3} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Butano / GLP:</span>
                            <span style={styles.value}>{item1.humo} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Monóxido de C:</span>
                            <span style={styles.value}>{item1.metanos} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>CO (alta conc.):</span>
                            <span style={styles.value}>{item1.vapores} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );

        case 'riego':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Irrigation Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Temperature:</span>
                            <span style={styles.value}>{item1.temperatura} °C</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Salinity:</span>
                            <span style={styles.value}>{item1.salinidad} mg/L</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Turbidity:</span>
                            <span style={styles.value}>{item1.turbidez} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        case 'salada':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Saltwater Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Temperature:</span>
                            <span style={styles.value}>{item1.temperatura} °C</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Turbidity:</span>
                            <span style={styles.value}>{item1.turbidez} NTU</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Salinity:</span>
                            <span style={styles.value}>{item1.salinidad} PSU</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Conductivity:</span>
                            <span style={styles.value}>{item1.conductividad}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Surf:</span>
                            <span style={styles.value}>{item1.oleaje}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>pH:</span>
                            <span style={styles.value}>{item1.pH}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Light intensity:</span>
                            <span style={styles.value}>{item1.intensidad} ppm</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        case 'suelo':
            return (
                <div style={styles.container}>
                    <h3 style={styles.header}>Soil Information</h3>
                    <div style={styles.card}>
                        <div style={styles.row}>
                            <span style={styles.label}>Date:</span>
                            <span style={styles.value}>{item1.fecha}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Time:</span>
                            <span style={styles.value}>{item1.hora}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Temperature:</span>
                            <span style={styles.value}>{item1.temperatura} °C</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Humidity:</span>
                            <span style={styles.value}>{item1.humedad} %</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Salinity:</span>
                            <span style={styles.value}>{item1.salinidad} %</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Conductivity:</span>
                            <span style={styles.value}>{item1.conductividad}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Air humidity:</span>
                            <span style={styles.value}>{item1.humedadAire} %</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Latitude:</span>
                            <span style={styles.value}>{item1.lat}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>Length:</span>
                            <span style={styles.value}>{item1.lon}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Node:</span>
                            <span style={styles.value}>{item1.idNodo}</span>
                        </div>
                        <div style={styles.row}>
                            <span style={styles.label}>ID Register:</span>
                            <span style={styles.value}>{item1.id}</span>
                        </div>
                    </div>
                </div>
            );
        default:
            return <p>No data avariable.</p>;
    }

};
// Solución para el icono por defecto
const defaultIcon = L.icon({
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const Map = () => {

    const Coordenadas = useSelector(state => state.coordenadas);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingResultados, setIsLoadingResultados] = useState(false);
    const [resultadosMeteorologicos, setResultadosMeteorologicos] = useState([]);

    useEffect(() => {
        if (isLoading) {
            setIsLoading(true);
            dispatch(coordenadas(Coordenadas)).finally(() => {
                setIsLoading(false);
                setIsLoadingResultados(true);
            });
        }
    }, [Coordenadas, isLoading]);

    useEffect(() => {
        const eliminarDuplicados = (lista) => {
            const seen = new Set(); // Para rastrear elementos únicos
            const uniqueList = [];

            lista.forEach(item => {
                // Crear una clave única basada en las coordenadas de `item1` y `item2` si existen
                const coordKey = `${item.item1?.lat},${item.item1?.lon},${item.item2?.lat || ''},${item.item2?.lon || ''}`;
                if (!seen.has(coordKey)) {
                    seen.add(coordKey); // Marcar como visto
                    uniqueList.push(item); // Agregar al resultado si no es duplicado
                }
            });

            return uniqueList;
        };

        const fetchMeteorologico = async () => {
            if (isLoadingResultados) {
                try {
                    const resultadosTemporales = []; // Almacenar resultados temporalmente

                    const promises = Coordenadas.current.map(async (coord) => {
                        const { lat, lon } = coord;
                        try {
                            const tipos = [
                                ultimoTesla,
                                ultimoMeteorologico,
                                ultimoDulce,
                                ultimoEntorno,
                                ultimoRiego,
                                ultimoSalada,
                                ultimoSuelo
                            ];

                            for (const accion of tipos) {
                                const res = await dispatch(accion({ lat, lon }));
                                if (res.payload && res.payload[0] != null) {
                                    // Agregar un objeto con `item1` y `item2` si existen
                                    resultadosTemporales.push({
                                        item1: res.payload[0],
                                        item2: res.payload[1] || null
                                    });
                                }
                            }
                        } catch (error) {
                            console.error(`Error al obtener datos para ${lat}, ${lon}:`, error);
                        }
                    });

                    await Promise.all(promises);

                    // Eliminamos duplicados y actualizamos el estado
                    const listaSinDuplicados = eliminarDuplicados(resultadosTemporales);
                    setResultadosMeteorologicos(listaSinDuplicados);
                } finally {
                    setIsLoading(false);
                    setIsLoadingResultados(false);
                }
            }
        };

        fetchMeteorologico();
    }, [isLoadingResultados, Coordenadas]);

    return (
        <>
            <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a class="navbar-brand ps-3" href="index.html">Multiparametric sensor</a>
                <form class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                </form>
            </nav>
            <div id="layoutSidenav">
                <div id="layoutSidenav_nav">
                    <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div class="sb-sidenav-menu">
                        </div>
                        <div class="sb-sidenav-footer">
                            <div class="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>
                <div id="layoutSidenav_content" class="flex-grow-1">
                    <MapContainer
                        center={[38.505277777778, -0.23277777777778]}
                        zoom={7}
                        minZoom={2}
                        className="map"
                        fullscreenControl={true}
                        aria-label="Mapa interactivo que muestra ubicaciones de dispositivos IoT desplegados"
                    >
                        <LayersControl position="topright">
                            <BaseLayer checked name="Mapbox Satellite">
                                <TileLayer
                                    url="https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWlndWVsemFyYWdvemFlc3F1ZXJkbyIsImEiOiJja2szNHdreG0wcHN4MnZxb2E0dzhtMTY2In0.WPnQXCR3lmry6KGqclie2A"
                                    attribution='&copy; <a href="https://www.mapbox.com/about/maps/">Mapbox</a> contributors'
                                    tileSize={512}
                                    zoomOffset={-1}
                                />
                            </BaseLayer>
                            <BaseLayer name="OpenStreetMap">
                                <TileLayer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                />
                            </BaseLayer>
                        </LayersControl>
                        <ScaleControl position="bottomleft" />
                        {resultadosMeteorologicos && resultadosMeteorologicos ?
                            resultadosMeteorologicos.map((marker) => (
                                <Marker
                                    key={`${marker.item1.lat}-${marker.item1.lon}`} // Usa una clave única
                                    position={[parseFloat(marker.item1.lat), parseFloat(marker.item1.lon)]}
                                    icon={defaultIcon}
                                    aria-label={`Marcador para ${marker.item1.lon}, ${marker.item1.lat}`}
                                >
                                    <Popup>
                                        <CustomPopup marker={marker} />
                                    </Popup>
                                </Marker>
                            )) : null}
                    </MapContainer>
                </div>
                <div id="layoutSidenav_nav">
                    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
                        <div className="sb-sidenav-menu">
                            <div className="nav">
                                <div className="sb-sidenav-menu-heading" id="titulo">Options</div>
                                <Link id="link" to="/">
                                    <button type="button" id="link" className={`btn btn-light`}>
                                        <div className="sb-nav-link-icon">
                                            <i className="fas fa-tachometer-alt"></i>
                                        </div>
                                        Back
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div className="sb-sidenav-footer">
                            <div className="small">MADE BY:</div>
                            miguelzaragozaesquerdo
                            @gmail.com
                        </div>
                    </nav>
                </div>

            </div>
        </>
    )
}

export default Map;
